import {
    PREFERRED_DESTINATION_LIST_REQUEST,
    PREFERRED_DESTINATION_LIST_SUCCESS,
    PREFERRED_DESTINATION_LIST_FAIL,
} from '../constants/countryConstants'

export const countryListReducer = (state = {}, action) => {
    switch (action.type) {
        case PREFERRED_DESTINATION_LIST_REQUEST:
            return { loading: true }
        case PREFERRED_DESTINATION_LIST_SUCCESS:
            return { loading: false, countries: action.payload }
        case PREFERRED_DESTINATION_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

